import PropTypes from 'prop-types';
import { Component } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import { editPropertyUrl } from 'automation-ui-references/routing/hubspotUrls';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import ObjectTypePropertiesContext from 'automation-ui-references/object-type-properties/ObjectTypePropertiesContext';
import { PropertyManagementModalIFrame } from 'property-management-iframe';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class EditPropertyLink extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isEditPropertyModalOpen: false
    };
    this.handleEditProperty = e => {
      e.stopPropagation();
      this.setState({
        isEditPropertyModalOpen: true
      });
    };
    this.handleCloseEditPropertyModal = () => {
      this.setState({
        isEditPropertyModalOpen: false
      });
    };
  }
  renderEditPropertyModal() {
    const {
      objectTypeId,
      onSave,
      propertyName
    } = this.props;
    return /*#__PURE__*/_jsx(PropertyManagementModalIFrame, {
      open: this.state.isEditPropertyModalOpen,
      mode: "EDIT",
      onClose: this.handleCloseEditPropertyModal,
      editParams: {
        objectTypeId,
        propertyName
      },
      onResult: onSave
    });
  }
  render() {
    const {
      isEmbedded,
      supportsCustomProperties
    } = this.context;
    const {
      objectTypeId,
      propertyName,
      children
    } = this.props;
    const {
      isEditPropertyModalOpen
    } = this.state;
    if (!supportsCustomProperties(objectTypeId)) {
      return children;
    }
    if (isEmbedded) {
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: editPropertyUrl(objectTypeId, propertyName),
        children: children
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [isEditPropertyModalOpen && this.renderEditPropertyModal(), /*#__PURE__*/_jsx(UILink, {
        onClick: this.handleEditProperty,
        children: children
      })]
    });
  }
}
EditPropertyLink.contextType = ObjectTypePropertiesContext;
EditPropertyLink.propTypes = {
  children: PropTypes.node.isRequired,
  objectTypeId: ObjectTypeIdType.isRequired,
  onSave: PropTypes.func,
  propertyName: PropTypes.string.isRequired
};
EditPropertyLink.defaultProps = {
  onSave: emptyFunction
};